export const iconFontAwesomeNatureFeatherPointed = (
	<i className="fa-solid fa-feather-pointed"></i>
);
